/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetVacanciesRequest,
  TGetVacanciesModel,
  IMappers,
  TGetVacanciesResponse_,
  TGetVacanciesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetVacanciesResponseV2 } from '../../entities/vacancies_listing/GetVacanciesResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetVacanciesModel(parameters: TGetVacanciesRequest): TGetVacanciesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'job-vacancies-backend',
    pathApi: '/v2/get-vacancies/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export const defaultConfig = createGetVacanciesModel({} as unknown as TGetVacanciesRequest);

export interface IGetVacanciesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetVacanciesRequest;
}

export async function fetchGetVacancies<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVacanciesOptions<TResponse200, TResponse400>): Promise<TGetVacanciesResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetVacanciesModel(parameters),
    config,
  )) as FetchResponse<TGetVacanciesResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVacanciesResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetVacanciesResponse;
}
